import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'uikit/avatars';
import styles from '../styles/quillMention.module.scss';

const QuillMention = ({
  name,
  avatarUrl,
}) => (
  <div className={styles.element}>
    <Avatar avatar={avatarUrl} name={name} size="small" />
    <div className={styles.name}>
      { name }
    </div>
  </div>
);

QuillMention.defaultProps = {
  name: '',
  avatarUrl: '',
};

QuillMention.propTypes = {
  name: PropTypes.string,
  avatarUrl: PropTypes.string,
};

export default QuillMention;
